import { BasicStandardYesNoDialogProperties } from "@goodgamestudios/core";
import { CommonDialogNames } from "@goodgamestudios/core";
import { TextFieldHelper } from "@goodgamestudios/core";
import { Poker2Dialog } from "./Poker2Dialog";

import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;

export class Poker2StandardYesNoDialog extends Poker2Dialog {
    public static NAME: string;

    constructor(disp: Container) {
        super(disp);
    }
    protected init(): void {
        super.init();
    }

    protected applyProperties(): void {
        this.standardDialog.btn_yes.label = this.standardDialogProperties.buttonLabel_yes;
        this.standardDialog.btn_no.label = this.standardDialogProperties.buttonLabel_no;
        TextFieldHelper.changeTextFromatSizeByTextWidth(12, this.standardDialog.txt_title, this.standardDialogProperties.title);
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.standardDialog.txt_copy, this.standardDialogProperties.copy, 7);
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);
        switch (event.target) {
            case this.standardDialog.btn_yes:
                this.hide();
                if (this.standardDialogProperties.functionYes != null)
                    this.standardDialogProperties.functionYes(null);
                break;
            case this.standardDialog.btn_close:
                this.hide();
                if (this.standardDialogProperties.functionClose != null)
                    this.standardDialogProperties.functionClose(null);
                break;
            case this.standardDialog.btn_no:
                this.hide();
                if (this.standardDialogProperties.functionNo != null)
                    this.standardDialogProperties.functionNo(null);
                break;
        }
    }

    protected get standardDialogProperties(): BasicStandardYesNoDialogProperties {
        return this.properties as BasicStandardYesNoDialogProperties;
    }

    protected get standardDialog(): Library.PokerInterface.PokerStandardYesNo {
        return this.disp as Library.PokerInterface.PokerStandardYesNo;
    }

    public static __initialize_static_members() {
        Poker2StandardYesNoDialog.NAME = CommonDialogNames.StandardYesNoDialog_NAME;
    }
}
Poker2StandardYesNoDialog.__initialize_static_members();
